import { createPortal } from 'react-dom'
import type { CheckoutDialogProps } from '../constants/orders'
import { cx } from '../helpers/format'
import { ButtonSpinner } from './ButtonSpinner'
import '../styles/checkout-dialog.scss'

export function CheckoutDialog({
  title,
  lead,
  cancelLabel,
  confirmLabel,
  confirming = false,
  confirmBusyLabel,
  labelledBy,
  describedBy,
  dialogLabel,
  closeAria,
  dismissible = true,
  marked = false,
  onCancel,
  onConfirm,
  children,
}: CheckoutDialogProps) {
  const showActions = Boolean(onConfirm && confirmLabel)

  return createPortal(
    <div
      className="checkout-dialog"
      role="dialog"
      aria-modal="true"
      aria-label={dialogLabel}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
    >
      <button
        type="button"
        className="checkout-dialog__backdrop"
        aria-label={closeAria}
        onClick={dismissible ? onCancel : undefined}
        disabled={confirming || !dismissible}
      />
      <div className={cx('checkout-dialog__panel', marked && 'checkout-dialog__panel--marked')}>
        {marked ? (
          <div className="checkout-dialog__mark" aria-hidden>
            <span className="checkout-dialog__bloom" />
          </div>
        ) : null}
        <h2 id={labelledBy}>{title}</h2>
        <p id={describedBy}>{lead}</p>
        {children}
        {showActions ? (
          <div className="checkout-dialog__actions">
            {onCancel && cancelLabel ? (
              <button type="button" onClick={onCancel} disabled={confirming}>
                {cancelLabel}
              </button>
            ) : null}
            <button
              type="button"
              className="checkout-dialog__proceed"
              onClick={onConfirm}
              disabled={confirming}
            >
              {confirming ? (
                <ButtonSpinner label={confirmBusyLabel ?? confirmLabel} />
              ) : (
                confirmLabel
              )}
            </button>
          </div>
        ) : null}
      </div>
    </div>,
    document.body,
  )
}
